import { withInstall } from '@tav-ui/utils/with-install'
import Time from './src/time.vue'
const TaTime = withInstall(Time)
export { TaTime }
export default TaTime
export * from './src/types'
